import React from 'react'

const VisionPage = () => {
  return (
 <div className="about-section">
      <span className="about-label">Vision</span>
      <div className="about-gold-bar" />
      <p className="about-body">
        To become the most trusted global advisory for transforming enterprise
        ambition into scalable, measurable outcomes.
      </p>
    </div>  )
}

export default VisionPage